import { inject } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { IExpirationSettings } from "@app/shared/expiration-settings/interfaces/expiration-settings.interface";
import { StockExpirationSettingsApiService } from "@app/shared/stock-expiration-settings/services/stock-expiration-settings-api.service";

export const stockExpirationSettingsResolver: ResolveFn<IExpirationSettings[]> = (route, _) => {
  const stockExpirationSettingsApiService = inject(StockExpirationSettingsApiService);
  return stockExpirationSettingsApiService.getStockExpirationSettings();
};
